import { useEffect } from 'react'
import { useUser } from '@clerk/clerk-react'
import {
  getPresenceChannel,
  releasePresenceChannel,
  trackPresence,
  untrackPresence,
} from '@/lib/presenceChannel'

/**
 * Hook that tracks user presence in the app using Supabase Realtime.
 * When a user is authenticated, their email is broadcast to the presence channel.
 * This allows admins to see who is currently active in the app.
 */
export function usePresence() {
  const { isSignedIn, user } = useUser()

  useEffect(() => {
    // Only track presence for signed-in users with an email
    if (!isSignedIn || !user?.primaryEmailAddress?.emailAddress) {
      return
    }

    const email = user.primaryEmailAddress.emailAddress
    const userId = user.id

    // Get the shared presence channel and track this user
    getPresenceChannel()
    trackPresence(userId, email)

    // Cleanup on unmount or when user signs out
    return () => {
      untrackPresence()
      releasePresenceChannel()
    }
  }, [isSignedIn, user?.id, user?.primaryEmailAddress?.emailAddress])
}
